module.exports = __webpack_public_path__ + "img/fuwu.d3d59480.png";